export const FLIGHT_CLASS_TYPE_MAPPING = {
    'GT17-BU': 'Business',
    'GT17-CO': 'Komfort',
    'GT17-EC': 'Economy',
    'GT17-PE': 'Economy Premium',
    'GT17-FI': 'First Class',
    'GT17-FALLBACK': '2. Klasse'
}
